import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

// Endpoints públicos de /auth: un 401 ahí significa "credenciales
// inválidas" (login) o simplemente no aplica (registro, recuperar
// contraseña, verificar email) — no hay sesión que cerrar en esos casos.
const PUBLIC_AUTH_PATHS = [
  '/auth/login',
  '/auth/register',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/check-email',
];

/**
 * No existe refresh token en este backend (ver auth.service.ts), así que un
 * 401 en cualquier llamada autenticada solo puede significar que el JWT
 * expiró o es inválido. Antes eso se tragaba en silencio (ej. fetchFreshUser
 * devolvía null sin limpiar nada) y la app quedaba "logueada" en el
 * localStorage mientras el servidor rechazaba todo. Este interceptor
 * detecta el 401 globalmente y fuerza un logout limpio + redirect a
 * /login, en vez de dejar la sesión en un estado inconsistente.
 */
export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        const isPublicAuthRequest = PUBLIC_AUTH_PATHS.some((path) => req.url.includes(path));
        if (!isPublicAuthRequest && authService.isLoggedIn()) {
          authService.handleSessionExpired();
        }
      }
      return throwError(() => error);
    })
  );
};
